import Icon from 'components/Icon'
import React from 'react'
import { OverlayTrigger } from 'react-bootstrap'
import { Placement } from 'react-bootstrap/esm/Overlay'
import styled from 'styled-components'
import { colors, _ } from 'utils'

const S = {
    PreviewImageButton: styled.span`
        margin-top: -6px;
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-left: 20px;
        color: ${colors.iconOpacity(0.8)};
        cursor: pointer;
        & > span {
            margin-bottom: 3px;
        }
    `,
    PreviewImagePopover: styled.div`
        width: 300px;
        height: 200px;
        background: white;
        padding: 8px;
        box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.4);
        border-radius: 5px;
    `,
    PreviewImage: styled.img`
        width: 100%;
        height: calc(100% - 35px);
        object-fit: contain;
        object-position: top left;
        margin-top: 8px;
    `,
    PreviewTitle: styled.span`
        font-size: 14px;
        color: ${colors.grayTitleOpacity(0.9)};
    `
}

type Props = {
    previewImagePlacement?: Placement
    image: string
}
const ImagePreviewPopover = ({ previewImagePlacement, image }: Props) => (
    <OverlayTrigger
        placement={previewImagePlacement}
        overlay={(
            <S.PreviewImagePopover id="preview-tooltip">
                <S.PreviewTitle>
                    {_('image.preview_title')}
                </S.PreviewTitle>
                <S.PreviewImage src={image} alt="preview" />
            </S.PreviewImagePopover>
        )}
    >
        <S.PreviewImageButton>
            <Icon icon="view" size={16} className="mr-2" />
            {_('image.preview_button')}
        </S.PreviewImageButton>
    </OverlayTrigger>
)

export default ImagePreviewPopover
